import React, { useEffect, useState } from "react";
import Card from "src/components/Cards/Basic";
import { Form, Formik } from "formik";
import FormInputText from "../../../../../components/Forms/FormInputText";
import FormCheckbox from "../../../../../components/Forms/FormCheckbox";
import { Button, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import axios from "../../../../../config/axios";
import { showSuccessToast } from "../../../../../components/Toasts";
import * as Yup from "yup";

const CustomEmailSettingsPage = () => {
  function submit(data, { setSubmitting, setErrors, resetForm }) {
    setSubmitting(true);
    setLoading(true);
    axios
      .put("api/v1/booking_settings/update_email.json", {
        email: data,
      })
      .then((response) => {
        setEmailSetting(response.data.settings);
        resetForm({
          values: { ...response.data.settings, smtp_password: "" },
        });
        showSuccessToast();
      })
      .catch(function (e) {
        setErrors(e.response.data);
      })
      .finally(() => {
        setSubmitting(false);
        setLoading(false);
      });
  }

  const [emailSetting, setEmailSetting] = useState({});
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation("dashboard");

  useEffect(() => {
    setLoading(true);
    axios.get("api/v1/booking_settings/show_email.json").then(({ data }) => {
      setEmailSetting(data.settings);
      setLoading(false);
    });
  }, []);

  return (
    <Card title={t("settings.email.custom_email.title")}>
      <p>{t("settings.email.custom_email.description")}</p>

      <Formik
        initialValues={{
          use_custom_smtp: emailSetting.use_custom_smtp ?? false,
          smtp_ssl: emailSetting.smtp_ssl ?? false,
          smtp_starttls_auto: emailSetting.smtp_starttls_auto ?? false,
          smtp_user_name: emailSetting.smtp_user_name ?? "",
          smtp_email: emailSetting.smtp_email ?? "",
          smtp_password: "",
          smtp_server: emailSetting.smtp_server ?? "",
          smtp_port: emailSetting.smtp_port ?? "",
          smtp_type: emailSetting.smtp_type,
        }}
        enableReinitialize={true}
        validationSchema={() => {
          return Yup.object().shape({
            use_custom_smtp: Yup.boolean(),

            smtp_user_name: Yup.string().when("use_custom_smtp", {
              is: true,
              then: (schema) =>
                schema.required(t("errors:errors.general.required")),
              otherwise: (schema) => schema.nullable(),
            }),

            smtp_email: Yup.string().when("use_custom_smtp", {
              is: true,
              then: (schema) =>
                schema
                  .email(t("errors:errors.general.invalid"))
                  .required(t("errors:errors.general.required")),
              otherwise: (schema) => schema.nullable(),
            }),

            smtp_password: Yup.string().when("use_custom_smtp", {
              is: true,
              then: (schema) =>
                schema.required(t("errors:errors.general.required")),
              otherwise: (schema) => schema.nullable(),
            }),

            smtp_server: Yup.string().when("use_custom_smtp", {
              is: true,
              then: (schema) =>
                schema.required(t("errors:errors.general.required")),
              otherwise: (schema) => schema.nullable(),
            }),

            smtp_port: Yup.number().when("use_custom_smtp", {
              is: true,
              then: (schema) =>
                schema
                  .typeError(t("errors:errors.general.invalid"))
                  .required(t("errors:errors.general.required")),
              otherwise: (schema) => schema.nullable(),
            }),
          });
        }}
        onSubmit={submit}
      >
        {({ values, isSubmitting }) => (
          <Form autoComplete="off">
            <FormCheckbox
              name="use_custom_smtp"
              label="Eigene E-Mail verwenden"
              className="mb-2"
            />

            {values.use_custom_smtp && (
              <>
                <FormInputText
                  required
                  name={"smtp_user_name"}
                  label={"Username"}
                  hint={"Der Username entspricht meist der E-Mail Adresse"}
                />
                <FormInputText
                  required
                  name={"smtp_server"}
                  label={"Server"}
                  hint={"Beispiel: smtps.aruba.it"}
                />
                <FormInputText
                  required
                  name={"smtp_port"}
                  type={"number"}
                  label={"Port"}
                />
                <FormInputText
                  required
                  name={"smtp_email"}
                  type={"email"}
                  label={"E-Mail"}
                />
                <FormInputText
                  required
                  name={"smtp_password"}
                  type={"password"}
                  label={"Passwort"}
                  hint={
                    "Das Passwort wird aus Sicherheitsgründen nachdem Speichern ausgeblendet"
                  }
                />

                <FormCheckbox
                  name="smtp_ssl"
                  label="SSL verwenden (typischerweise bei Port 465)"
                  className="mb-2"
                />
                <FormCheckbox
                  name="smtp_starttls_auto"
                  label="StartTLS verwenden (typischerweise bei Port 587)"
                  className="mb-2"
                />
              </>
            )}
            <Button type={"submit"} disabled={isSubmitting} type="submit">
              <div className={"d-flex align-items-center"}>
                {loading && (
                  <Spinner
                    className={"d-block mr-2"}
                    size={"sm"}
                    animation="border"
                    variant="secondary"
                  />
                )}
                {t("common:components.button.save")}
              </div>
            </Button>
          </Form>
        )}
      </Formik>
    </Card>
  );
};

export default CustomEmailSettingsPage;
